const  TeamsData = [ {
    Employee_ID: "XASDADSA98",
    Employee_Name: "John Doe",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:120000,
    Team_status:'inactive',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA00",
    Employee_Name: "Eila Clintion",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:12000,
    Team_status:'active',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Mike Tyler",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:12000,
    Team_status:'inactive',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Marie Arch",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:1200,
    Team_status:'active',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Mike Tyler",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:120000,
    Team_status:'active',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Marie ARch",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:120000,
    Team_status:'active',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Eila Clintion",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:120000,
    Team_status:'active',
    Last_order : '18 months'
  },
  {
    Employee_ID: "XASDADSA98",
    Employee_Name: "Eila Clintion",
    Team_name: "Name 1 2",
    Credit_on: "28/06/22",
    Department:"Electronics",
    Amount:120000,
    Team_status:'active',
    Last_order : '18 months'
  },
];

export {TeamsData};